import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { OrderTrakingModel, ResultFraudAnalysis } from '../model/order-blocked.model';
import { headersBase } from '../../../../helper/headerBase';

@Injectable()
export class OrderBlockedServiceRest {
  constructor(
    private http: HttpClient
  ) {
  }

  public getOrderBlocked(param: string, page: number, dailyPurchaseLimitExceeded: string): Observable<OrderTrakingModel> {
    return this.http.get<OrderTrakingModel>(`Order/Getorders/${page}/${param}?dailyPurchaseLimitExceeded=${dailyPurchaseLimitExceeded}`, headersBase() );
  }

  public putResultFraudAnalysis(orderId: string, purchaseLimit: string): Observable<ResultFraudAnalysis> {
    return this.http.put<ResultFraudAnalysis>(`Order/PutResultFraudAnalysis/${orderId}?purchaseLimit=${purchaseLimit}`, null, headersBase());
  }
}

